<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template lang="html">
  <section class="identity-provider">
    <h1>identity-provider Component</h1>
    <router-link tag="a" to="/login?token=294de3557d9d00b3d2d8a1e6aab028cf&exp=0&status=success"
                 class="btn btn-success">
      Login as guest
    </router-link>
    <router-link tag="a" to="/login?token=a2b8ed9c305b8ea86116b603cca78a97&exp=0&status=success"
                 class="btn btn-success">
      Login
    </router-link>
  </section>
</template>

<script lang="js">
import { mapMutations } from 'vuex';

export default {
  name: 'identity-provider',
  props: [],
  mounted() {
    this.appReady(true);
  },
  data() {
    return {};
  },
  methods: {
    ...mapMutations([
      'appReady',
    ]),
  },
};
</script>
<style scoped lang="scss">
.identity-provider {

}
</style>
